import {
  COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES, PERCENTAGES,
  BACKGROUND_IMAGE_POSITION, BUTTON_TYPE, FONT_FAMILIES, FONT_SIZES, APP_HANDLERS
} from 'shared/constants';

const propsSchema = [
  {
    key: 'slides',
    label: 'Slides',
    type: types.ARRAY,
    children: [
      {
        key: 'text_animation',
        label: 'Text Animation',
        type: types.BOOLEAN
      },
      {
        key: 'play_on_enter',
        label: 'Start Play When Enters Viewport',
        type: types.BOOLEAN
      },
      {
        key: 'loop',
        label: 'Loop',
        type: types.BOOLEAN
      },
      {
        key: 'hidden',
        label: 'Hide Slide',
        type: types.BOOLEAN
      },
      {
        key: 'color_theme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      },
      {
        key: 'slide_link',
        label: 'Slide Link',
        type: types.TEXT
      },
      {
        key: 'bg_video',
        label: 'Background Video',
        type: types.OBJECT,
        options: false,
        children: [
          {
            key: 'url',
            label: 'Video Link',
            type: types.TEXT
          },
          {
            key: 'cover',
            label: 'Video Cover',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'bg_image',
        label: 'Background Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT
          },
          {
            key: 'dark_overlay',
            label: 'Dark Overlay',
            type: types.ENUM,
            options: PERCENTAGES
          },
          {
            key: 'position',
            label: 'Background Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          }
        ]
      },
      {
        key: 'bg_image_mobile',
        label: 'Background Image (Mobile)',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT
          },
          {
            key: 'dark_overlay',
            label: 'Dark Overlay',
            type: types.ENUM,
            options: PERCENTAGES
          },
          {
            key: 'position',
            label: 'Background Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          }
        ]
      },
      {
        key: 'cta_block',
        label: 'CTA Block',
        type: types.OBJECT,
        option: false,
        children: [
          {
            key: 'section',
            label: 'Section Label',
            type: types.TEXT
          },
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'title_font_family',
            label: 'Title Font Family',
            type: types.ENUM,
            options: FONT_FAMILIES
          },
          {
            key: 'title_logo',
            label: 'Title Logo (replaces Title text)',
            type: types.S3_ASSET_URL
          },
          {
            key: 'subtitle',
            label: 'Subtitle',
            type: types.TEXT
          },
          {
            key: 'subtitle_font_family',
            label: 'Subtitle Font Family',
            type: types.ENUM,
            options: FONT_FAMILIES
          },
          {
            key: 'subtitle_font_size',
            label: 'Subtitle Font Size',
            type: types.ENUM,
            options: FONT_SIZES
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT
          },
          {
            key: 'show_button_divider',
            label: 'Show button dividers',
            type: types.BOOLEAN
          },
          {
            key: 'button_style',
            label: 'Button Style',
            type: types.ENUM,
            options: BUTTON_TYPE
          },
          {
            key: 'buttons',
            label: 'Buttons',
            type: types.ARRAY,
            children: [
              {
                key: 'label',
                label: 'Button Label',
                type: types.TEXT
              },
              {
                key: 'icon',
                label: 'Icon',
                type: types.ICON
              },
              {
                key: 'app_handler',
                label: 'Use App Handler',
                type: types.ENUM,
                options: APP_HANDLERS
              },
              {
                key: 'url',
                label: 'URL',
                type: types.TEXT
              },
              {
                key: 'open_in_new_tab',
                label: 'Open in New Tab',
                type: types.BOOLEAN
              },
              {
                key: 'hide_for_blocked_areas',
                label: 'Hide for Blocked Areas',
                type: types.BOOLEAN
              },
              {
                key: 'launch_video',
                label: 'Launch video player',
                type: types.BOOLEAN
              },
            ]
          },
          {
            key: 'socialLinks',
            label: 'Social Links',
            type: types.ARRAY,
            option: false,
            children: [
              {
                key: 'url',
                label: 'URL',
                type: types.TEXT
              },
              {
                key: 'icon',
                label: 'Icon',
                type: types.ICON
              }
            ]
          },
          {
            key: 'top_left_icon',
            label: 'Top Left Icon',
            type: types.OBJECT,
            children: [
              {
                key: 'label',
                label: 'Button Label',
                type: types.TEXT
              },
              {
                key: 'icon',
                label: 'Icon',
                type: types.ICON
              },
              {
                key: 'app_handler',
                label: 'Use App Handler',
                type: types.ENUM,
                options: APP_HANDLERS
              },
              {
                key: 'url',
                label: 'URL',
                type: types.TEXT
              },
              {
                key: 'open_in_new_tab',
                label: 'Open in New Tab',
                type: types.BOOLEAN
              },
              {
                key: 'hide_for_blocked_areas',
                label: 'Hide for Blocked Areas',
                type: types.BOOLEAN
              },
              {
                key: 'launch_video',
                label: 'Launch video player',
                type: types.BOOLEAN
              },
            ]
          },
          {
            key: 'show_share_icon',
            label: 'Show Share Icon',
            type: types.BOOLEAN
          },
          {
            key: 'share_icon',
            label: 'Share Icon Metadata',
            type: types.OBJECT,
            children: [
              {
                key: 'url',
                label: 'Url',
                type: types.TEXT
              },
              {
                key: 'title',
                label: 'Title',
                type: types.TEXT
              },
              {
                key: 'description',
                label: 'Description',
                type: types.TEXT
              },
              {
                key: 'image',
                label: 'Image',
                type: types.S3_ASSET_URL
              },
              {
                key: 'icon',
                label: 'icon',
                type: types.ICON
              },
            ]
          },
        ]
      },
      {
        key: 'highlights',
        label: 'Highlights',
        type: types.ARRAY,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT
          },
        ]
      },
      {
        key: 'bottom_buttons_padding',
        label: 'Bottom Buttons Padding (ex: "20px")',
        type: types.TEXT
      },
      {
        key: 'bottom_buttons',
        label: 'Bottom Buttons',
        type: types.ARRAY,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT
          },
          {
            key: 'app_handler',
            label: 'Use App Handler',
            type: types.ENUM,
            options: APP_HANDLERS
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
          {
            key: 'open_in_new_tab',
            label: 'Open in New Tab',
            type: types.BOOLEAN
          },
        ]
      },
    ]
  },
  {
    key: 'showScrollIndicator',
    label: 'Show Scroll Indicator',
    type: types.BOOLEAN
  },
  {
    key: 'carouselAutoplaySpeed',
    label: 'Autoplay Speed (in seconds)',
    type: types.TEXT
  },
  {
    key: 'isAppPage',
    label: 'In-App page',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  slides: [
    {
      text_animation: false,
      play_on_enter: false,
      loop: true,
      hidden: false,
      color_theme: 'DARK',
      bg_image: {
        url: '',
        dark_overlay: 0,
        position: 'CENTER CENTER'
      },
      bg_image_mobile: {
        url: '',
        dark_overlay: 0,
        position: 'CENTER CENTER'
      },
      bg_video: {
        url: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_ff91_emergence_3mbps.mp4',
        cover: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_cover_image.jpg'
      },
      cta_block: {
        section: '',
        title: 'experience a new species',
        title_logo: '',
        subtitle: '',
        description: '',
        show_button_divider: false,
        button_style: 'UNDERLINE',
        buttons: [
          {
            label: 'explore ff 91',
            icon: '',
            app_handler: 'None',
            url: '/ff-91',
            open_in_new_tab: false,
            hide_for_blocked_areas: false,
            launch_video: false
          },
          {
            label: 'preorder',
            app_handler: 'None',
            url: '/preorder',
            open_in_new_tab: false,
            hide_for_blocked_areas: false,
            launch_video: false
          }
        ],
        socialLinks: [
          { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
          { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
          { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
          { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
          { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
        ],
        show_share_icon: false,
        share_icon: {
          url: 'https://www.ff.com/us/ff-91',
          title: 'FF 91',
          description: '',
          icon: 'ff-icon-share-arrow'
        },
      },
      highlights: [],
      bottom_buttons: []
    }
  ],
  carouselAutoplaySpeed: '5',
  showScrollIndicator: false,
  isAppPage: false
};

export default {
  title: 'Page Carousel',
  id: 'VideoImageCarousel',
  widgetImage: '/widgetImages/Page+carousel.png',
  basic: true,
  propsSchema,
  defaultProps
};
